<div class="d-flex justify-content-center">
  <div>
    <h1>{{ 'THANK_YOU_FOR_USING_OUR_SERVICE' | translate }}</h1>
    <p>{{ 'EVALUATE_THE_CONVENIENCE_OF_THE_SERVICE' | translate }}</p>
    <div>
      <div class="mb-3 font-size-16 d-flex align-items-end">
        <app-mark [value]="rate" (onClickMark)="onClickMark($event)"></app-mark>
      </div>
    </div>
    <dx-button
      text="{{ 'NEXT' | translate }}"
      (onClick)="this.callRate()"
      [disabled]="!this.rate"
      class="btn"
      icon="mdi mdi-chevron-right"></dx-button>
  </div>
</div>
